// extracted by mini-css-extract-plugin
export var container = "_92-0";
export var icon = "_92-1";
export var text = "_92-2";